import Quill from 'quill'
import {MapParamObjectTag} from './MapParamObjectTag'
import {MapParamOperator} from './MapParamOperator'
import {MapParamFunction} from './MapParamFunction'
import {MAP_PARAM_COMPLEX_EXPR} from '../index'

const TextBlock = Quill.import('blots/text')
const Inline = Quill.import('blots/inline')
const Block = Quill.import('blots/block')
const BlockEmbed = Quill.import('blots/block/embed')

export class MapParamComplexExpression extends Inline {
    static tagName = 'i'
    static blotName = MAP_PARAM_COMPLEX_EXPR
    static className = MAP_PARAM_COMPLEX_EXPR

    static allowedChildren = [
        MapParamObjectTag,
        MapParamOperator,
        MapParamFunction,
        TextBlock,
        Inline,
        Block,
        BlockEmbed
    ]

    // eslint-disable-next-line no-useless-constructor
    constructor(domNode) {
        super(domNode)
        // domNode.addEventListener('click', this.clickHandler)
    }

    static register() {
        Quill.register(MapParamComplexExpression)
    }

    static create({value = ' '}) {
        const node = super.create()
        node.innerHTML = value
        node.contentEditable = true
        node.dataset[_.camelCase(MAP_PARAM_COMPLEX_EXPR)] = 'true'
        node.dataset.placeholder = 'Expression'
        return node
    }

// clickHandler(event) {
// console.log('click expresion: ', this);
// }
}
